/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  ConfirmUploadDto,
  DataEnvelopeOfAttachmentDto,
  DataEnvelopeOfObject,
  DataEnvelopeOfPresignResponseDto,
  ErrorEnvelope,
  PresignRequestDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Use PUT direto com Content-Type e If-None-Match: *. Reutilizar a URL não permite substituir o objeto já enviado.
 * @summary Gera URL pré-assinada para criar arquivo sem sobrescrever uma chave existente
 */
export const generatePresignedUrl = (
  presignRequestDto: PresignRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfPresignResponseDto>(
    {
      url: `/v1/uploads/presign`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: presignRequestDto,
      signal,
    },
    options,
  )
}

export const getGeneratePresignedUrlMutationKey = () => ['generatePresignedUrl'] as const

export const getGeneratePresignedUrlMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePresignedUrl>>,
    TError,
    GeneratePresignedUrlMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError,
  GeneratePresignedUrlMutationVariables,
  TContext
> => {
  const mutationKey = getGeneratePresignedUrlMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePresignedUrl>>,
    GeneratePresignedUrlMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return generatePresignedUrl(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type GeneratePresignedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePresignedUrl>>
>
export type GeneratePresignedUrlMutationBody = PresignRequestDto
export type GeneratePresignedUrlMutationError = ErrorEnvelope
export type GeneratePresignedUrlMutationVariables = { data: PresignRequestDto }

/**
 * @summary Gera URL pré-assinada para criar arquivo sem sobrescrever uma chave existente
 */
export const useGeneratePresignedUrl = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generatePresignedUrl>>,
      TError,
      GeneratePresignedUrlMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generatePresignedUrl>>,
  TError,
  GeneratePresignedUrlMutationVariables,
  TContext
> => {
  return useMutation(getGeneratePresignedUrlMutationOptions(options), queryClient)
}
/**
 * @summary Confirma upload e registra metadados
 */
export const confirmUpload = (
  confirmUploadDto: ConfirmUploadDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfAttachmentDto>(
    {
      url: `/v1/uploads/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmUploadDto,
      signal,
    },
    options,
  )
}

export const getConfirmUploadMutationKey = () => ['confirmUpload'] as const

export const getConfirmUploadMutationOptions = <
  TError = ErrorEnvelope,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmUpload>>,
    TError,
    ConfirmUploadMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmUpload>>,
  TError,
  ConfirmUploadMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmUploadMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmUpload>>,
    ConfirmUploadMutationVariables
  > = (props) => {
    const { data } = props ?? {}

    return confirmUpload(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ConfirmUploadMutationResult = NonNullable<Awaited<ReturnType<typeof confirmUpload>>>
export type ConfirmUploadMutationBody = ConfirmUploadDto
export type ConfirmUploadMutationError = ErrorEnvelope
export type ConfirmUploadMutationVariables = { data: ConfirmUploadDto }

/**
 * @summary Confirma upload e registra metadados
 */
export const useConfirmUpload = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof confirmUpload>>,
      TError,
      ConfirmUploadMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof confirmUpload>>,
  TError,
  ConfirmUploadMutationVariables,
  TContext
> => {
  return useMutation(getConfirmUploadMutationOptions(options), queryClient)
}
/**
 * @summary Remove arquivo do R2
 */
export const deleteFile = (
  key: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfObject>(
    { url: `/v1/uploads/${key}`, method: 'DELETE', signal },
    options,
  )
}

export const getDeleteFileMutationKey = () => ['deleteFile'] as const

export const getDeleteFileMutationOptions = <TError = ErrorEnvelope, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    DeleteFileMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  DeleteFileMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteFileMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile>>,
    DeleteFileMutationVariables
  > = (props) => {
    const { key } = props ?? {}

    return deleteFile(key, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFile>>>

export type DeleteFileMutationError = ErrorEnvelope
export type DeleteFileMutationVariables = { key: string }

/**
 * @summary Remove arquivo do R2
 */
export const useDeleteFile = <TError = ErrorEnvelope, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFile>>,
      TError,
      DeleteFileMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  DeleteFileMutationVariables,
  TContext
> => {
  return useMutation(getDeleteFileMutationOptions(options), queryClient)
}
